import { render } from "./logs-page.vue?vue&type=template&id=4631e646&ts=true"
import script from "./logs-page.ts?vue&type=script&lang=ts"
export * from "./logs-page.ts?vue&type=script&lang=ts"

import "./logs-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__